import store from "../store";
import BaseModel from "../../models/baseModel";

export default class SingleSelectedDecorator<T extends BaseModel> {
  private _afterSet: () => void

  constructor(protected propertyName: string, protected modelTypeGetter: () => new (...args) => T, afterSet?: (item: T) => void) {
    this._afterSet = afterSet
  }

  is(item: T): boolean {
    return this.get() === item;
  }

  get isNull(): boolean {
    const val = this.get()
    return val === null || val === undefined;
  }

  hasId(id: string): boolean {
    const item = this.get();
    const unknownItem = <any>item;
    const unknownItemId = unknownItem.client_id || unknownItem.id;
    return item && unknownItemId && unknownItemId === id;
  }

  get(): T {
    const item = store.getters[`selected/getSingle`](this.propertyName)
    if (item?.markedForDestruction) return null
    return item
  }

  set(item: T) {
    store.commit(`selected/setSingle`, { key: this.propertyName, item: item });
    if(this._afterSet instanceof Function) {
      this._afterSet(item);
    }
  }

  deselect(): void {
    if (this.isNull) return;

    this.set(null);
  }

  deselectIf(item: T): void {
    if (this.is(item)) {
      this.deselect();
    }
  }

  deselectIfHasId(id: string): void {
    if (this.hasId(id)) {
      this.set(null);
    }
  }

  state(): { [key: string]: T } {
    const state = {};
    state[this.propertyName] = null;
    return state;
  }
}